module.exports = __webpack_public_path__ + "static/media/server_4.fbc2a5fb.png";